module.exports = __webpack_public_path__ + "media/images/bg_image/img_bg_image_home_commercial-fcbff40c3ebc2c43b071cf0517dfd735.png";